class CheckoutValidator {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // checkout btn cart block
    $(document).on('click', '.new-mini-checkout', (evt) => {
      this.checkoutHandlerMinicart(evt);
    });

    // checkout btn cart block
    $(document).on('click', '.new-checkout-block', (evt) => {
      this.chekoutHandler(evt);
    });

    // checkout btn cart footer
    $(document).on('click', '.new-checkout', (evt) => {
      this.chekoutHandler(evt);
    });
  }

  async chekoutHandler(evt) {
    console.log('Regular checkout button clicked');
    evt.preventDefault();

    const button = $(evt.currentTarget);
    await this.performValidationAndCheckout(button);
  }

  async checkoutHandlerMinicart(evt) {
    evt.preventDefault();
    document.querySelectorAll(".qun-error-message").forEach(element => {
      element.style.display = "none";
      element.textContent = ""
    });
    document.querySelector("#cart-notification").classList.add("minicart-active")
    const button = $(evt.currentTarget);
    await this.performValidationAndCheckout(button);
  }

  async performValidationAndCheckout(button) {
    try {
      // Show loading state
      this.setLoadingState(button, true);

      const validationResult = await this.validateWithAPI();

      if (validationResult.success) {
        // console.log('validations passed - proceeding to checkout');
        this.proceedToCheckout();
      } else {
        console.log('Validation failed:', validationResult);
        document.querySelectorAll(".qun-error-message").forEach(element => {
          element.style.display = "block";
          element.innerHTML = validationResult.message
        });
      }

    } catch (error) {
      console.error('Validation error:', error);
    } finally {
      this.setLoadingState(button, false);
    }
  }

  async validateWithAPI() {
    let availModelCodes = [];
    // let availModelCodes = [
    //   "MYE73ZP/A",
    //   "MYEA3ZP/A",
    //   "MYED3ZP/A",
    //   "MYEC3ZP/A",
    //   "MYE93ZP/A",
    //   "MYEE3ZP/A",
    //   "MYEG3ZP/A",
    //   "MYEJ3ZP/A",
    //   "MYEH3ZP/A",
    //   "MYEF3ZP/A",
    //   "MYEK3ZP/A",
    //   "MYEQ3ZP/A",
    //   "MYEU3ZP/A",
    //   "MYER3ZP/A",
    //   "MYEP3ZP/A",
    //   "MXVU3ZP/A",
    //   "MXVW3ZP/A",
    //   "MXVY3ZP/A",
    //   "MXVX3ZP/A",
    //   "MXVV3ZP/A",
    //   "MXWN3ZP/A",
    //   "MXY13ZP/A",
    //   "MXY53ZP/A",
    //   "MXY23ZP/A",
    //   "MXWV3ZP/A",
    //   "MY1P3ZP/A",
    //   "MY253ZP/A",
    //   "MY2J3ZP/A",
    //   "MY2D3ZP/A",
    //   "MY1X3ZP/A",
    //   "MYND3ZP/A",
    //   "MYNF3ZP/A",
    //   "MYNG3ZP/A",
    //   "MYNE3ZP/A",
    //   "MYNR3ZP/A",
    //   "MYNW3ZP/A",
    //   "MYNX3ZP/A",
    //   "MYNT3ZP/A",
    //   "MYNH3ZP/A",
    //   "MYNK3ZP/A",
    //   "MYNL3ZP/A",
    //   "MYNJ3ZP/A",
    //   "MYNM3ZP/A",
    //   "MYNP3ZP/A",
    //   "MYNQ3ZP/A",
    //   "MYNN3ZP/A",
    //   "MYX43ZP/A",
    //   "MYX63ZP/A",
    //   "MYX73ZP/A",
    //   "MYX53ZP/A",
    //   "MYWV3ZP/A",
    //   "MYWX3ZP/A",
    //   "MYWY3ZP/A",
    //   "MYWW3ZP/A",
    //   "MYX03ZP/A",
    //   "MYX23ZP/A",
    //   "MYX33ZP/A",
    //   "MYX13ZP/A",
    //   "MD1Q4ZP/A",
    //   "MD1R4ZP/A",
    //   "MD1T4ZP/A",
    //   "MD1W4ZP/A",
    //   "MD1X4ZP/A",
    //   "MD274ZP/A"
    // ]
    const storeCode = document.querySelector(".my-store-locator__info").dataset.storeCode || "S0EC";
    let modelCodes = Array.from(document.querySelectorAll('.cart-item')).map(item => item.getAttribute('data-sku'));

    if (modelCodes.length === 0) {
      modelCodes = Array.from(document.querySelectorAll('.cartmini.cartitem')).map(item => item.getAttribute('data-sku'));
    }

    // Check if any of the SKUs in cart are in the allowed list
    const hasAvailableSku = modelCodes.some(code => availModelCodes.includes(code));
    if (!hasAvailableSku) {
      // Skip API call completely
      console.log("No cart items found in availModelCodes. Skipping API validation.");
      return { success: true };
    }

    let filteredModelCodes = modelCodes.filter(code => availModelCodes.includes(code));

    try {
      const response = await fetch('https://www.istudiobyspvi.com/apps/stock/check-stock', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          langCode: "EN",
          pullAllStatus: "N",
          "storeCodes": [
            storeCode
          ],
          modelCodes: filteredModelCodes
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.data.status === "500") {
        return {
          success: false,
          message: 'Some items are not available for checkout. Please review your cart.'
        };
      }

      if (result.data.status === "200") {
        let errors = [];

        modelCodes.forEach(code => {
          const item = result.data.items.find(i => i.modelCode === code);
          if (item) {
            let requestedQty =
              parseInt(document.querySelector(`.cart-item[data-sku='${code}'] .cart-item__quantity .quantity__input`)?.value, 10) || 1;

            let cartItemName =
              document.querySelector(`.cart-item[data-sku='${code}'] .cart-item__details .cart-item__name`)?.innerText ||
              document.querySelector(`.cartmini.cartitem[data-sku='${code}'] .cart-notification-product__name`)?.innerText ||
              code;

            // checks
            if (item.availableQty === 0) {
              errors.push(`${cartItemName} is out of stock. Please change store or select another product.`);
            } else if (requestedQty > item.availableQty) {
              errors.push(`${cartItemName}: You are ordering more units than available at this location.`);
            }
          }
        });

        if (errors.length > 0) {
          return { success: false, message: errors.join("<br>") };
             
        } else {
          console.log("All model codes are available.");
          return { success: true };
        }
      }
    } catch (error) {
      console.error("Error fetching check stock:", error);
      return { success: false };
    }
  }

  setLoadingState(button, isLoading) {
    if (isLoading) {
      button.prop('disabled', true);
      if (button.text && button.text() !== '') {
        button.data('original-text', button.text());
        button.text('Validating...');
      }
    } else {
      button.prop('disabled', false);
      const originalText = button.data('original-text');
      if (originalText) {
        button.text(originalText);
        button.removeData('original-text');
      }
    }
  }

  proceedToCheckout() {
    window.location.href = `${window.Shopify.routes.root}checkout`;
  }
}

$(document).ready(() => {
  window.checkoutValidator = new CheckoutValidator();
}); 